const KEY = 'fa_sessions_v1';

export const storageService = {
  save(key, value) {
    localStorage.setItem(`${KEY}:${key}`, JSON.stringify(value));
  },
  load(key, fallback = null) {
    const raw = localStorage.getItem(`${KEY}:${key}`);
    if (!raw) return fallback;
    try { return JSON.parse(raw); } catch { return fallback; }
  },
  remove(key) {
    localStorage.removeItem(`${KEY}:${key}`);
  },
};
